import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.object.to-string.js";
import React from 'react';
import Notification from '../../wui-notification/src';
import classnames from 'classnames';
import warning from 'warning';
import { prefix } from "../../wui-core/src/index.js";
var defaultDuration = 1.5;
var newDuration;
var defaultTop = 24;
var defaultBottom = 48;
var bottom = 90;
var padding = 30;
var width = 227;
var messageInstance;
var key = 1;
var clsPrefix = "".concat(prefix, "-message");

var noop = function noop() {};

var notificationStyle_copy = {};
var messageStyle_copy = {};
var positionType = ['topRight', 'bottomRight', 'top', 'bottom', 'topLeft', 'bottomLeft', ''];
var defaultStyle = {};
var positionObj = {
  "top": {
    messageStyle: {},
    notificationStyle: {
      top: defaultTop,
      left: '50%',
      transform: 'translateX( -50%)'
    },
    transitionName: 'top'
  },
  "bottom": {
    messageStyle: {},
    notificationStyle: {
      bottom: defaultBottom,
      left: '50%',
      transform: 'translateX( -50%)'
    },
    transitionName: 'bottom'
  },
  "topRight": {
    messageStyle: {
      width: width
    },
    notificationStyle: {
      top: padding,
      right: padding,
      width: width
    },
    transitionName: 'right'
  },
  "bottomRight": {
    messageStyle: {
      width: width
    },
    notificationStyle: {
      bottom: bottom,
      right: padding,
      width: width
    },
    transitionName: 'right'
  },
  "topLeft": {
    messageStyle: {
      width: width
    },
    notificationStyle: {
      top: padding,
      left: padding,
      width: width
    },
    transitionName: 'left'
  },
  "bottomLeft": {
    messageStyle: {
      width: width
    },
    notificationStyle: {
      bottom: bottom,
      left: padding,
      width: width
    },
    transitionName: 'left'
  }
};

function getMessageInstance() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'top';
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  var keyboard = arguments.length > 2 ? arguments[2] : undefined;
  var onEscapeKeyUp = arguments.length > 3 ? arguments[3] : undefined;

  if (messageInstance) {
    callback(messageInstance);
    return;
  }

  switch (position) {
    case 'top':
      notificationStyle_copy.top = defaultTop;
      break;

    case 'bottom':
      notificationStyle_copy.bottom = defaultBottom;
      break;

    case 'bottomRight':
      notificationStyle_copy.bottom = bottom;
      break;

    case 'bottomLeft':
      notificationStyle_copy.bottom = bottom;
      break;

    default:
      break;
  }

  if (position !== 'top' && position !== 'bottom') {
    messageStyle_copy.width = width;
  }

  var style = JSON.stringify(notificationStyle_copy) == "{}" ? positionObj[position].notificationStyle : notificationStyle_copy;
  var instanceObj = {
    clsPrefix: clsPrefix,
    transitionName: "".concat(clsPrefix, "-").concat(positionObj[position].transitionName),
    style: Object.assign({}, style, defaultStyle),
    // 覆盖原来的样式
    position: position
  };

  if (typeof keyboard === 'boolean') {
    instanceObj.keyboard = keyboard;
  }

  if (typeof onEscapeKeyUp === 'function') {
    instanceObj.onEscapeKeyUp = onEscapeKeyUp;
  }

  Notification.newInstance(instanceObj, function (instance) {
    messageInstance = instance;
    callback(instance);
  });
}

function notice(content, duration_arg, type, onClose, position, style, keyboard, onEscapeKeyUp, showIcon, icon, props) {
  if (positionType.findIndex(function (item) {
    return item === position;
  }) < 0) {
    warning(false, 'Failed prop type: Invalid prop `position` supplied to `Message`, expected one of ["top","bottom","topRight","topLeft","bottomRight","bottomLeft"].');
    return;
  }

  var duration = duration_arg !== undefined ? duration_arg : defaultDuration;
  notificationStyle_copy = Object.assign({}, positionObj[position].notificationStyle);
  messageStyle_copy = Object.assign({}, positionObj[position].messageStyle);
  var iconType = {
    info: 'uf uf-i-c',
    success: 'uf uf-correct',
    danger: 'uf uf-exc-c',
    warning: 'uf uf-exc-t',
    light: 'uf uf-notification',
    dark: 'uf uf-notification',
    news: 'uf uf-bell',
    infolight: 'uf uf-i-c',
    successlight: 'uf uf-correct',
    dangerlight: 'uf uf-exc-c',
    warninglight: 'uf uf-exc-t'
  }[type];
  var positionStyle = JSON.stringify(messageStyle_copy) == "{}" ? positionObj[position].messageStyle : messageStyle_copy;
  defaultStyle = Object.assign({}, positionStyle, style);
  getMessageInstance(position, function (instance) {
    instance.notice(_objectSpread(_objectSpread({}, props), {}, {
      key: key,
      duration: duration,
      color: type,
      style: Object.assign({}, positionStyle, style),
      content: /*#__PURE__*/React.createElement("div", null, showIcon ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-notice-description-icon")
      }, icon ? /*#__PURE__*/React.createElement("i", {
        className: classnames("".concat(icon))
      }) : /*#__PURE__*/React.createElement("i", {
        className: classnames(iconType)
      })) : null, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-notice-description-content")
      }, content)),
      onClose: onClose
    }));
  }, keyboard, onEscapeKeyUp);
  return function () {
    var target = key++;
    return function () {
      if (messageInstance) {
        messageInstance.removeNotice(target);
      }
    };
  }();
}

function isArgsProps(content) {
  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
}

var api = {
  create: function create(obj) {
    if (newDuration) {
      //如果在config方法里设置了duration
      obj.duration = newDuration;
    }

    var content = obj.message || obj.content || '';
    var duration = typeof obj.duration == 'undefined' ? defaultDuration : obj.duration;
    var color = obj.color || 'light';
    var onClose = obj.onClose || noop;
    var position = obj.position || "top";
    var style = obj.style || {};
    var showIcon = obj.hasOwnProperty('showIcon') ? obj.showIcon : true;
    var icon = obj.hasOwnProperty('icon') ? obj.icon : false;
    return notice(content, duration, color, onClose, position, style, obj.keyboard, obj.onEscapeKeyUp, showIcon, icon, obj);
  },
  config: function config(options) {
    if (options.top !== undefined) {
      defaultTop = options.top;
    }

    if (options.duration !== undefined) {
      defaultDuration = options.duration;
      newDuration = defaultDuration;
    }

    if (options.clsPrefix !== undefined) {
      clsPrefix = options.clsPrefix;
    }

    if (options.defaultBottom !== undefined) {
      defaultBottom = options.defaultBottom;
    }

    if (options.bottom !== undefined) {
      bottom = options.bottom;
    }

    if (options.width !== undefined) {
      width = options.width;
    }
  },
  destroy: function destroy() {
    if (messageInstance) {
      messageInstance.destroy();
      messageInstance = null;
      defaultDuration = 1.5;
      newDuration = undefined;
      defaultTop = 24;
      defaultBottom = 48;
      bottom = 90;
      padding = 30;
      width = 227;
      notificationStyle_copy = null;
      messageStyle_copy = null;
      defaultStyle = null;
    }
  }
};
['success', 'info', 'warning', 'error', 'loading', 'infolight', 'successlight', 'dangerlight', 'warninglight'].forEach(function (type) {
  api[type] = function (config) {
    var content = config.content,
        message = config.message,
        duration = config.duration,
        onClose = config.onClose;
    content = message || content;
    if (typeof config === "string") content = config;

    if (isArgsProps(content)) {
      return api.create(_objectSpread(_objectSpread({}, content), {}, {
        color: type
      }));
    }

    if (typeof duration === 'function') {
      onClose = duration;
      duration = undefined;
    }

    return api.create({
      content: content,
      duration: duration,
      color: type === 'error' ? 'danger' : type,
      onClose: onClose
    });
  };
});
api.warn = api.warning;
export default api;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-message/src/Message.js